export default __webpack_public_path__ + "static/media/3083.b41c6ac5.jpg";